"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBasedGateway = void 0;
const Constants_1 = require("../Constants");
const Gateway_1 = require("./Gateway");
/**
 * Describes an EventBasedGateway.
 *
 * Currently not supported.
 */
class EventBasedGateway extends Gateway_1.Gateway {
    get bpmnType() {
        return Constants_1.BpmnType.eventBasedGateway;
    }
}
exports.EventBasedGateway = EventBasedGateway;
//# sourceMappingURL=EventBasedGateway.js.map